export default __webpack_public_path__ + "static/up_down_w.8d472f397ed34163ea11a2f14b78289d.svg";